if (!customElements.get('hp-deals-marquee')) {
  customElements.define('hp-deals-marquee', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-deals-viewport]');
      this.track = this.querySelector('[data-deals-track]');
      this.group = this.querySelector('[data-deals-group]');
      this.toggle = this.querySelector('[data-deals-toggle]');
      if (!this.group || !this.group.children.length) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.clone = this.group.cloneNode(true);
      this.clone.removeAttribute('data-deals-group');
      this.clone.setAttribute('data-deals-clone', '');
      this.clone.setAttribute('aria-hidden', 'true');
      this.clone.querySelectorAll('a').forEach(link => link.tabIndex = -1);
      this.clone.querySelectorAll('[data-shopify-editor-block]').forEach(block => block.removeAttribute('data-shopify-editor-block'));
      this.track.append(this.clone);

      this.toggle.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? 'Resume scrolling offers' : 'Pause scrolling offers');
      }, options);
      this.viewport.addEventListener('focusin', () => {
        this.setAttribute('data-static', '');
        const focused = document.activeElement;
        if (this.group.contains(focused)) focused.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, options);
      this.viewport.addEventListener('focusout', event => {
        if (this.viewport.contains(event.relatedTarget)) return;
        this.removeAttribute('data-static');
        this.viewport.scrollLeft = 0;
      }, options);
      document.addEventListener('visibilitychange', () => this.toggleAttribute('data-background', document.hidden), options);
      this.addEventListener('shopify:block:select', () => this.setAttribute('data-static', ''), options);
      this.addEventListener('shopify:block:deselect', () => this.removeAttribute('data-static'), options);
      this.motion.addEventListener('change', () => this.updateMotion(), options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.viewport);
      this.observer.observe(this.group);
      this.updateMotion();
    }

    measure() {
      this.style.setProperty('--hp-deals-width', `${this.viewport.clientWidth}px`);
      this.style.setProperty('--hp-deals-duration', `${Math.max(20, this.group.getBoundingClientRect().width / 32)}s`);
    }

    updateMotion() {
      this.toggleAttribute('data-animated', !this.motion.matches);
      this.toggle.hidden = this.motion.matches;
      this.clone.hidden = this.motion.matches;
      this.viewport.scrollLeft = 0;
      this.measure();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.clone?.remove();
    }
  });
}

if (!customElements.get('hp-collection-tiles')) {
  customElements.define('hp-collection-tiles', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-collections-track]');
      this.previous = this.querySelector('[data-collections-previous]');
      this.next = this.querySelector('[data-collections-next]');
      if (!this.track || !this.track.children.length) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('focusin', event => {
        if (event.target.matches('a')) event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, options);
      this.addEventListener('shopify:block:select', event => event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' }), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }

    move(direction) {
      const width = this.track.firstElementChild.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.previous.hidden = this.next.hidden = maximum < 2;
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
